import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { CommonService, StorageService } from '../services';

@Injectable({ providedIn: 'root' })
export class PermissionGuard  {
  constructor(
    private readonly commonService: CommonService,
    private readonly storageService: StorageService,
    private readonly router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean | UrlTree {
    const requiredModule = route.data?.['module'] as string | undefined;
    return this.validateAccess(requiredModule);
  }

  canLoad(route: Route, _segments: UrlSegment[]): boolean | UrlTree {
    const requiredModule = route.data?.['module'] as string | undefined;
    return this.validateAccess(requiredModule);
  }

  private validateAccess(requiredModule?: string): boolean | UrlTree {
    if (!this.storageService.get('isLoggedIn')) {
      return this.router.parseUrl('/login');
    }

    if (!requiredModule) {
      return true;
    }

    const permissions = this.commonService.getPermissions() || [];
    const hasAccess = this.commonService.hasModuleTreeAccess(requiredModule, permissions);

    if (hasAccess) {
      return true;
    }

    return this.router.parseUrl('/profile-setting');
  }
}